/* ============================================================
   basic.lab — Customer Hub Widget (v3 — Klaviyo-style)
   ============================================================
   4 tabs : Accueil · Commandes · Club · Profil
   Vanilla JS, no deps, ~600 lines
   ============================================================ */
(function () {
  'use strict';

  // ============================================================
  // CONFIG
  // ============================================================
  const LOGO_URL = 'https://basic-cosmetics.bio/cdn/shop/files/basic_black.png?v=1741897875&width=180';
  const SUPABASE_URL = 'https://dnszapxdvzirbchcpqni.supabase.co';
  const SUPABASE_ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRuc3phcHhkdnppcmJjaGNwcW5pIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzYzMzg1MjQsImV4cCI6MjA5MTkxNDUyNH0.oMFXF0Un2yvbPJFy4gsqrEWClesV6a-AMzJH5My-D9M';
  const EDGE_FN_URL = SUPABASE_URL + '/functions/v1/basic-lab-chat';

  // Headers Supabase — sans `apikey` car non autorisé par CORS depuis le browser.
  // Seulement Content-Type + Authorization Bearer (le JWT anon suffit côté Supabase).
  function supaHeaders() {
    return {
      'Authorization': 'Bearer ' + SUPABASE_ANON,
      'Content-Type': 'application/json'
    };
  }

  // ============================================================
  // STATE
  // ============================================================
  const state = {
    open: false,
    tab: 'home',
    orderFilter: 'all',
    sessionId: null,
    conversationId: null,
    messages: [],
    chatMessages: [],
    chatCsat: null,
    chatPollTimer: null,
    chatLoaded: false,
    faqsRequested: false,
    escapeBound: false,
    customer: null,
    orders: [],
    shop: { free_shipping_threshold: 70, gift_threshold: 90 }
  };

  // ============================================================
  // ICONS (inline SVG, monochrome)
  // ============================================================
  const ICO = {
    flask:   '<svg viewBox="0 0 24 24"><path d="M9 3h6v4h4v8a5 5 0 0 1-5 5h-4a5 5 0 0 1-5-5V7h4z"/><line x1="9" y1="3" x2="9" y2="7"/><line x1="15" y1="3" x2="15" y2="7"/><circle cx="12" cy="13" r="1.4" fill="currentColor" stroke="none"/></svg>',
    heartFill:'<svg viewBox="0 0 24 24"><path d="M12 21s-7-4.5-9.5-9.2C.5 7.5 4 3 8 4.5c1.7.6 3 2 4 3.5 1-1.5 2.3-2.9 4-3.5 4-1.5 7.5 3 5.5 7.3C19 16.5 12 21 12 21z"/></svg>',
    close:   '<svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
    home:    '<svg viewBox="0 0 24 24"><path d="M3 11l9-8 9 8v9a2 2 0 0 1-2 2h-4v-7h-6v7H5a2 2 0 0 1-2-2z"/></svg>',
    box:     '<svg viewBox="0 0 24 24"><path d="M3 7l9-4 9 4v10l-9 4-9-4z"/><polyline points="3 7 12 11 21 7"/><line x1="12" y1="11" x2="12" y2="21"/></svg>',
    star:    '<svg viewBox="0 0 24 24"><polygon points="12 2 14.6 8.6 22 9.3 16.5 14.3 18 21 12 17.5 6 21 7.5 14.3 2 9.3 9.4 8.6"/></svg>',
    user:    '<svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 4-7 8-7s8 3 8 7"/></svg>',
    truck:   '<svg viewBox="0 0 24 24"><rect x="1" y="6" width="14" height="11" rx="1"/><polyline points="15 9 19 9 22 13 22 17 15 17"/><circle cx="6" cy="19" r="2"/><circle cx="18" cy="19" r="2"/></svg>',
    leaf:    '<svg viewBox="0 0 24 24"><path d="M4 20C4 10 10 4 20 4c0 10-6 16-16 16z"/><path d="M4 20L14 10"/></svg>',
    swiss:   '<svg viewBox="0 0 24 24"><rect x="3.5" y="3.5" width="17" height="17" rx="1.5"/><path d="M12 8v8M8 12h8"/></svg>',
    refill:  '<svg viewBox="0 0 24 24"><path d="M21 12a9 9 0 1 1-3.2-6.9"/><polyline points="21 4 21 9 16 9"/></svg>',
    drop:    '<svg viewBox="0 0 24 24"><path d="M12 3C8 8 5 11 5 15a7 7 0 0 0 14 0c0-4-3-7-7-12z"/></svg>',
    sparkle: '<svg viewBox="0 0 24 24"><path d="M12 3L13.5 10.5L21 12L13.5 13.5L12 21L10.5 13.5L3 12L10.5 10.5z"/></svg>',
    gift:    '<svg viewBox="0 0 24 24"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>',
    quiz:    '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M9.1 9a3 3 0 1 1 5.8 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12" y2="17.01"/></svg>',
    heart:   '<svg viewBox="0 0 24 24"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21.2l7.8-7.8 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>',
    chat:    '<svg viewBox="0 0 24 24"><path d="M4 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-6l-5 4v-4H6a2 2 0 0 1-2-2z"/></svg>',
    pin:     '<svg viewBox="0 0 24 24"><path d="M12 22s-7-7-7-13a7 7 0 0 1 14 0c0 6-7 13-7 13z"/><circle cx="12" cy="9" r="2.5"/></svg>',
    arrow:   '<svg viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="13 6 19 12 13 18"/></svg>',
    check:   '<svg viewBox="0 0 24 24"><polyline points="5 12 10 17 19 8"/></svg>',
    percent: '<svg viewBox="0 0 24 24"><line x1="6" y1="18" x2="18" y2="6"/><circle cx="7.5" cy="7.5" r="2.5"/><circle cx="16.5" cy="16.5" r="2.5"/></svg>',
    bell:    '<svg viewBox="0 0 24 24"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.7 21a2 2 0 0 1-3.4 0"/></svg>',
    lock:    '<svg viewBox="0 0 24 24"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>',
    cake:    '<svg viewBox="0 0 24 24"><path d="M3 21h18v-8a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3z"/><path d="M3 17h18M9 6V4M12 6V3M15 6V4"/></svg>'
  };

  // ============================================================
  // INIT
  // ============================================================
  function init() {
    state.sessionId = getSessionId();
    const dataEl = document.getElementById('basic-lab-data');
    if (dataEl) {
      try {
        const d = JSON.parse(dataEl.textContent);
        state.customer = d.customer || null;
        state.orders = d.orders || [];
        state.shop = Object.assign(state.shop, d.shop || {});
      } catch (e) {}
    }
    state.conversationId = getStoredConversationId();
    trackRecentlyViewed();
    render();
    attachEvents();
    // Si une conversation existe déjà, précharge les messages (badge non-lus)
    if (state.conversationId) fetchChatMessages();
  }

  // ============================================================
  // SYNC FAQ depuis basic. lab v2
  // ============================================================
  async function fetchFAQs() {
    try {
      const res = await fetch(EDGE_FN_URL + '/faq', { headers: supaHeaders() });
      if (!res.ok) return;
      const data = await res.json();
      const list = Array.isArray(data.faq) ? data.faq : (data.faqs || []);
      if (list.length > 0) {
        // Mapper sur le format attendu — supporte 2 schémas :
        // (a) {question, answer, category}
        // (b) {trigger_keywords: [question, category], reply_text: answer}  ← basic. lab v2
        state.remoteFaqs = list.map(f => {
          if (f.trigger_keywords && Array.isArray(f.trigger_keywords)) {
            return {
              q: f.trigger_keywords[0] || '',
              cat: f.trigger_keywords[1] || 'Autres',
              a: f.reply_text || ''
            };
          }
          return {
            cat: f.category || f.cat || 'Autres',
            q: f.question || f.q || '',
            a: f.answer || f.a || ''
          };
        }).filter(f => f.q && f.a);
        // Re-render help pane si déjà construit
        const helpPane = document.querySelector('[data-pane="help"]');
        if (helpPane) {
          helpPane.outerHTML = buildHelp();
          attachHelpEvents();
        }
      }
    } catch (e) { /* silent : fallback aux hardcoded */ }
  }

  function getActiveFaqs() {
    return (state.remoteFaqs && state.remoteFaqs.length > 0) ? state.remoteFaqs : FAQS;
  }

  // Track product pages → localStorage (for "vus récemment")
  function trackRecentlyViewed() {
    if (!/\/products\//.test(location.pathname)) return;
    // Scrape minimal data from the page
    const handle = location.pathname.replace(/.*\/products\//, '').split(/[?#]/)[0];
    if (!handle) return;
    const og = document.querySelector('meta[property="og:title"]');
    const ogImg = document.querySelector('meta[property="og:image"]');
    const ogPrice = document.querySelector('meta[property="product:price:amount"]');
    const title = (og && og.content) || document.title.split(/[|—–-]/)[0].trim();
    const image = ogImg && ogImg.content;
    const price = ogPrice && ogPrice.content;
    const entry = { handle, title, image, price, ts: Date.now() };
    try {
      const list = JSON.parse(localStorage.getItem('bl_recent') || '[]')
        .filter(x => x.handle !== handle);
      list.unshift(entry);
      localStorage.setItem('bl_recent', JSON.stringify(list.slice(0, 8)));
    } catch (e) {}
  }
  function getRecentlyViewed() {
    try {
      let list = JSON.parse(localStorage.getItem('bl_recent') || '[]');
      // Filtre B2B : retire kits & produits B2C-only
      if (isB2B()) {
        list = list.filter(p => !isB2COnlyHandle(p.handle));
      }
      return list;
    } catch (e) { return []; }
  }

  // ===== B2B helpers =====
  function isB2B() {
    return !!(state.customer && state.customer.is_b2b === true);
  }
  function isB2COnlyHandle(handle) {
    if (!handle) return false;
    const h = handle.toLowerCase();
    // Kits, packs et baumes lèvres avec applicateur sont B2C-only chez basic.
    return /^kit-|-kit-de-depart|^pack-|-rechargeable-kit/.test(h);
  }

  function getSessionId() {
    // localStorage (persiste entre visites) + migration depuis sessionStorage
    let sid = localStorage.getItem('bl_session') || sessionStorage.getItem('bl_session');
    if (!sid) {
      sid = 'bl_' + (crypto.randomUUID ? crypto.randomUUID() : Date.now() + Math.random());
    }
    try { localStorage.setItem('bl_session', sid); } catch (e) {}
    return sid;
  }

  function getStoredConversationId() {
    return localStorage.getItem('bl_conversation') || null;
  }
  function setStoredConversationId(id) {
    try { localStorage.setItem('bl_conversation', id); } catch (e) {}
  }
  function getChatEmail() {
    const c = state.customer;
    if (c && c.email) return c.email;
    return localStorage.getItem('bl_email') || '';
  }
  function setChatEmail(email) {
    try { localStorage.setItem('bl_email', email); } catch (e) {}
  }

  // ============================================================
  // RENDER ROOT
  // ============================================================
  function render() {
    const existing = document.getElementById('basic-lab-widget');
    if (existing) existing.remove();
    const root = document.createElement('div');
    root.id = 'basic-lab-widget';
    root.innerHTML = state.open ? buildShell() : buildLauncher();
    document.body.appendChild(root);
    injectIosFixes();
  }

  // iOS Safari : le panneau ne s'affiche pas sans ces overrides.
  // - 100vh inclut la barre URL iOS et déborde du viewport visible
  // - position: fixed + transform peut bugger sans hardware accel
  // - height -webkit-fill-available est le fallback fiable < iOS 16
  function injectIosFixes() {
    if (document.getElementById('bl-ios-fix')) return;
    const css = `
      #basic-lab-widget .bl-panel{
        position: fixed !important;
        top: 0 !important;
        right: 0 !important;
        left: auto !important;
        bottom: auto !important;
        width: min(440px, 100vw) !important;
        max-width: 100vw !important;
        height: 100vh !important;
        height: 100dvh !important;
        height: -webkit-fill-available;
        max-height: 100vh;
        max-height: 100dvh;
        transform: translate3d(100%, 0, 0) !important;
        -webkit-transform: translate3d(100%, 0, 0) !important;
        transition: transform .28s ease !important;
        -webkit-transition: -webkit-transform .28s ease !important;
        will-change: transform;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        z-index: 2147483646 !important;
        display: flex !important;
        flex-direction: column !important;
        overflow: hidden;
        visibility: visible !important;
        opacity: 1 !important;
        pointer-events: auto !important;
        background: #fff;
      }
      #basic-lab-widget .bl-panel.bl-panel--open{
        transform: translate3d(0, 0, 0) !important;
        -webkit-transform: translate3d(0, 0, 0) !important;
      }
      #basic-lab-widget .bl-content{
        -webkit-overflow-scrolling: touch;
        overflow-y: auto;
        flex: 1 1 auto;
        min-height: 0;
      }
      #basic-lab-widget .bl-overlay{ z-index: 2147483645; }
      #basic-lab-widget .bl-fab{ z-index: 2147483644; }
      /* Évite que l'input zoom auto iOS sur focus (font-size >= 16px) */
      #basic-lab-widget input, #basic-lab-widget textarea, #basic-lab-widget select{
        font-size: 16px;
      }
      /* Safe-area iPhone bas (encoche / barre home) */
      #basic-lab-widget .bl-nav{ padding-bottom: env(safe-area-inset-bottom, 0); }
      /* Lock body scroll quand panneau ouvert */
      body.bl-lock{ overflow: hidden !important; position: fixed; width: 100%; }
    `;
    const style = document.createElement('style');
    style.id = 'bl-ios-fix';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function buildLauncher() {
    return `
      <button class="bl-fab" id="bl-fab" aria-label="Ouvrir basic.">
        ${ICO.heartFill}
        <span class="bl-fab__badge" id="bl-badge">0</span>
      </button>
    `;
  }

  function buildShell() {
    const b2b = isB2B();
    const subLabel = b2b ? '·&nbsp;<em>espace pro</em>' : '·&nbsp;ton espace';
    return `
      ${buildLauncher()}
      <div class="bl-overlay" id="bl-overlay"></div>
      <div class="bl-panel" id="bl-panel" role="dialog" aria-label="Customer Hub basic.">
        <div class="bl-header">
          <div class="bl-header__brand">
            <img class="bl-header__logo" src="${LOGO_URL}" alt="basic.">
            <span class="bl-header__sub">${subLabel}</span>
          </div>
          <button class="bl-header__close" id="bl-close" aria-label="Fermer">${ICO.close}</button>
        </div>
        <div class="bl-content">
          ${buildHome()}
          ${buildOrders()}
          ${b2b ? '' : buildClub()}
          ${buildHelp()}
          ${buildProfile()}
        </div>
        <div class="bl-nav">
          <button class="bl-nav__item bl-nav__item--active" data-tab="home"      aria-label="Accueil">${ICO.home}</button>
          <button class="bl-nav__item"                      data-tab="orders"   aria-label="Commandes">${ICO.box}</button>
          ${b2b ? '' : `<button class="bl-nav__item" data-tab="club" aria-label="Club">${ICO.star}</button>`}
          <button class="bl-nav__item"                      data-tab="help"     aria-label="Aide">${ICO.chat}</button>
          <button class="bl-nav__item"                      data-tab="profile"  aria-label="Profil">${ICO.user}</button>
        </div>
        <div class="bl-toast" id="bl-toast"></div>
      </div>
    `;
  }

  // ============================================================
  // FAQ DATA — 20 questions essentielles depuis la knowledge base
  // ============================================================
  const FAQS = [
    { cat: 'Livraison', q: 'Combien coûte la livraison ?',                a: 'CHF 7.00 en Suisse. Offerte dès <strong>CHF 70</strong> d\'achat.' },
    { cat: 'Livraison', q: 'Quel délai pour recevoir ma commande ?',      a: 'Préparation 1 jour ouvrable, puis 1 à 3 jours via La Poste Suisse. Compte 2 à 4 jours ouvrables au total.' },
    { cat: 'Livraison', q: 'Vous livrez où ?',                            a: 'Exclusivement en Suisse pour le moment. Pour l\'étranger, écris-nous à <a href="mailto:cs@basicbrand.ch">cs@basicbrand.ch</a>.' },
    { cat: 'Livraison', q: 'Comment suivre mon colis ?',                  a: 'Tu reçois un email avec un lien de suivi La Poste dès l\'expédition. Tu peux aussi consulter le statut dans ton compte basic.' },
    { cat: 'Livraison', q: 'Je veux modifier mon adresse',                a: 'Si la commande n\'est pas encore expédiée, écris-nous à <a href="mailto:cs@basicbrand.ch">cs@basicbrand.ch</a> avec le numéro de commande.' },

    { cat: 'Produits',  q: 'Vos produits sont-ils vegan ?',               a: 'Oui, 100 % vegan, certifiés PETA Cruelty-Free. Aucun ingrédient d\'origine animale, aucun test.' },
    { cat: 'Produits',  q: 'Vos cosmétiques sont-ils bio ?',              a: 'En moyenne 95-98 % des ingrédients par formule sont bio. Le pourcentage exact figure sur chaque fiche produit.' },
    { cat: 'Produits',  q: 'Conviennent-ils aux peaux sensibles ?',       a: 'Oui, plusieurs références sont conçues pour les peaux sensibles (sérum CALM, savon laurier). Le diagnostic visage te guide.' },
    { cat: 'Produits',  q: 'Compatibles grossesse ?',                     a: 'La plupart de nos formules oui, mais certaines huiles essentielles sont déconseillées. Vérifie l\'INCI ou demande-nous.' },
    { cat: 'Produits',  q: 'Combien dure un déodorant ?',                 a: 'En usage quotidien sur deux aisselles, environ 2 à 3 mois. La recharge KIIMA prend le relais ensuite.' },

    { cat: 'Compte',    q: 'Comment créer mon compte ?',                  a: 'En 30 secondes via <a data-k-hub-ignore="true" href="/account/register">/account/register</a>. Tu reçois 100 points de bienvenue et un -20% à utiliser sur ta première commande.' },
    { cat: 'Compte',    q: 'J\'ai oublié mon mot de passe',               a: 'Sur la page connexion, clique « mot de passe oublié ». Tu reçois un email de réinitialisation en quelques secondes.' },
    { cat: 'Compte',    q: 'Comment modifier mon adresse ?',              a: 'Onglet <strong>Profil</strong> de ton espace basic., puis « Modifier l\'adresse ». Ou directement via <a data-k-hub-ignore="true" href="/account/addresses">/account/addresses</a>.' },
    { cat: 'Compte',    q: 'Supprimer mon compte ?',                      a: 'Écris à <a href="mailto:cs@basicbrand.ch">cs@basicbrand.ch</a>. Suppression effective sous 30 jours conformément à la nLPD suisse.' },
    { cat: 'Compte',    q: 'Mes données sont-elles protégées ?',          a: 'Oui, hébergement Shopify (PCI-DSS niveau 1), paiements Shopify Payments. Tes données bancaires ne transitent jamais par nos serveurs.' },

    { cat: 'Le Club',   q: 'Comment fonctionnent les points ?',           a: '1 CHF dépensé = 5 points. À partir de 100 points cumulés tu peux les convertir en remise au checkout.' },
    { cat: 'Le Club',   q: 'C\'est quoi les paliers ?',                   a: 'Essentiel (0+), Signature (750+), Iconique (1500+). Plus tu es fidèle, plus tes avantages sont importants : remise permanente, livraison offerte plus tôt, cadeaux.' },
    { cat: 'Le Club',   q: 'Comment fonctionne le parrainage ?',          a: 'Ton code unique offre 250 points à ton filleul et tu en reçois 250 quand il commande. Code copiable depuis l\'onglet <strong>Club</strong>.' },
    { cat: 'Le Club',   q: 'Puis-je retourner un produit ?',              a: '14 jours après réception. Max 2 produits par commande, non ouverts. Les applicateurs KIIMA ne sont pas repris (hygiène).' },
    { cat: 'Le Club',   q: 'Comment se passe le remboursement ?',         a: 'Sous 14 jours après réception du retour, via le moyen de paiement initial. Frais de livraison initiaux non remboursés.' }
  ];

  // ============================================================
  // TAB : AIDE (FAQ + chat)
  // ============================================================
  function buildHelp() {
    const faqs = getActiveFaqs();
    // Catégories : 'Tout' + uniques détectées
    const uniqueCats = [...new Set(faqs.map(f => f.cat))].filter(Boolean);
    const cats = ['Tout', ...uniqueCats];
    const filterChips = cats.map((c, i) => `
      <button class="bl-filter-tab ${i === 0 ? 'bl-filter-tab--active' : ''}" data-faq-cat="${escapeAttr(c)}">${escapeHTML(c)}</button>
    `).join('');

    const faqItems = faqs.map((f, i) => `
      <details class="bl-faq-item" data-faq-cat="${escapeAttr(f.cat)}">
        <summary class="bl-faq-q">
          <span>${escapeHTML(f.q)}</span>
          <span class="bl-faq-icon">+</span>
        </summary>
        <div class="bl-faq-a">${f.a}</div>
      </details>
    `).join('');

    const hasEmail = !!getChatEmail();
    return `
      <div class="bl-tab-pane" data-pane="help">
        <div class="bl-pane">

          <!-- CHAT EN PREMIER : action principale -->
          <div class="bl-chat-hero">
            <div class="bl-chat-hero__head">
              <img class="bl-avatar" src="https://basic-cosmetics.bio/cdn/shop/files/raluca_support.jpg?v=1773226498&width=120" alt="Raluca" loading="lazy" width="40" height="40" style="object-fit:cover;border-radius:50%;display:block;">
              <div class="bl-chat-hero__intro">
                <div class="bl-chat-hero__title">Écris-nous.</div>
                <div class="bl-chat-hero__sub">Raluca te répond personnellement. On garde le fil ici même.</div>
              </div>
            </div>

            <!-- FIL DE DISCUSSION (live) -->
            <div id="bl-chat-thread" style="display:none;max-height:340px;overflow-y:auto;padding:12px;background:var(--bl-cream,#F4EFE6);border-radius:12px;margin-bottom:10px;-webkit-overflow-scrolling:touch;"></div>

            <!-- COMPOSER -->
            <div class="bl-chat-card">
              ${hasEmail ? '' : `
              <input type="email" id="bl-chat-email" inputmode="email" autocomplete="email"
                placeholder="Ton email (pour qu'on puisse te répondre)"
                style="width:100%;font-size:16px;padding:10px 12px;border:1px solid var(--bl-ink-20,#e0ddd6);border-radius:8px;margin-bottom:8px;font-family:inherit;background:#fff;outline:none;">`}
              <textarea id="bl-chat-input" class="bl-chat-textarea" rows="3" placeholder="Pose ta question, on revient vers toi vite…"></textarea>
              <div class="bl-chat-card__foot">
                <span class="bl-chat-card__hint" id="bl-chat-hint">Réponse en 24h ouvrées</span>
                <button class="bl-btn bl-btn--primary bl-btn--sm" id="bl-chat-send">Envoyer</button>
              </div>
            </div>
          </div>

          <!-- WHATSAPP : alternative instantanée -->
          <a class="bl-whatsapp" href="https://wa.me/41775070982?text=Bonjour%20basic.%2C%20j%27ai%20une%20question%20%3A%20" target="_blank" rel="noopener">
            <div class="bl-whatsapp__icon">
              <svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.5 14.4c-.3-.1-1.7-.8-2-.9-.3-.1-.4-.1-.6.1-.2.3-.7.9-.8 1-.2.2-.3.2-.6.1-.3-.2-1.2-.4-2.3-1.4-.8-.8-1.4-1.7-1.6-2-.2-.3 0-.5.1-.6.1-.1.3-.3.4-.5.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5-.1-.1-.6-1.5-.9-2.1-.2-.5-.5-.5-.6-.5h-.5c-.2 0-.5.1-.7.3-.3.3-1 1-1 2.4 0 1.4 1 2.8 1.2 3 .1.2 2 3.1 4.9 4.3.7.3 1.2.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.7-.7 2-1.4.2-.7.2-1.3.2-1.4 0-.2-.2-.3-.4-.4z M12 2a10 10 0 0 0-8.7 15l-1.3 4.8 5-1.3A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3.1.8.8-3-.2-.3a8.2 8.2 0 1 1 7 3.9z"/></svg>
            </div>
            <div class="bl-whatsapp__body">
              <div class="bl-whatsapp__title">WhatsApp</div>
              <div class="bl-whatsapp__sub">Réponse plus rapide en journée · +41 77 507 09 82</div>
            </div>
            <span class="bl-whatsapp__arrow">→</span>
          </a>

          <!-- Alternatives discrètes -->
          <div class="bl-chat-alts" style="text-align:center;justify-content:center;">
            <a href="mailto:cs@basicbrand.ch">cs@basicbrand.ch</a>
          </div>

          <!-- DIVIDER subtil -->
          <div class="bl-or-divider"><span>ou trouve ta réponse</span></div>

          <!-- FAQ EN SECOND : navigation secondaire -->
          <div>
            <div class="bl-section-head">
              <span class="bl-section-title">Questions fréquentes</span>
            </div>
            <div class="bl-filter-tabs" data-faq-filter-bar>
              ${filterChips}
            </div>
            <div class="bl-faq-list" id="bl-faq-list">
              ${faqItems}
            </div>
          </div>
        </div>
      </div>
    `;
  }

  // ============================================================
  // TAB : ACCUEIL
  // ============================================================
  function buildHome() {
    const c = state.customer;
    const o = state.orders && state.orders[0];
    const firstName = c ? ((c.first_name || c.name || '').split(' ')[0] || 'toi') : null;
    const tier = c ? tierFromCustomer(c) : null;
    const tierLabel = tier ? { essentiel: 'Essentiel', signature: 'Signature', iconique: 'Iconique' }[tier] : '';
    const orderCard = o ? buildOrderTrackingCard(o) : '';
    const recent = getRecentlyViewed();

    const greeting = c ? (isB2B() ? `
      <div class="bl-greeting">
        <div class="bl-greeting__title">Bonjour ${escapeHTML(firstName)}.</div>
        <div class="bl-greeting__sub">Ton espace professionnel basic. — suivi commande, catalogue B2B, contact pro et réglages compte.</div>
        <div class="bl-greeting__meta">
          <span class="bl-pill bl-pill--ink">Compte pro</span>
          <span class="bl-pill bl-pill--cream">${c.orders_count || 0} commande${(c.orders_count||0) > 1 ? 's' : ''}</span>
        </div>
      </div>
    ` : `
      <div class="bl-greeting">
        <div class="bl-greeting__title">Bonjour ${escapeHTML(firstName)}.</div>
        <div class="bl-greeting__sub">Ton espace basic. — commandes, fidélité, parrainage et réglages, ici en un seul endroit.</div>
        <div class="bl-greeting__meta">
          <span class="bl-pill bl-tier-pill--${tier}">${tierLabel}</span>
          <span class="bl-pill bl-pill--cream">${c.orders_count || 0} commande${(c.orders_count||0) > 1 ? 's' : ''}</span>
        </div>
      </div>
    `) : `
      <div class="bl-greeting">
        <div class="bl-greeting__title">Bienvenue.</div>
        <div class="bl-greeting__sub">Connecte-toi pour suivre tes commandes, gérer ton compte et accéder à ton Club basic.</div>
        <div class="bl-greeting__meta">
          <a data-k-hub-ignore="true" href="/account/login" class="bl-btn bl-btn--primary bl-btn--sm">Se connecter</a>
        </div>
      </div>
    `;

    // Hero feature card — adapté selon profil (B2B vs B2C)
    const showB2B = isB2B();
    const heroCard = showB2B ? `
      <a class="bl-hero-card" href="/pages/professionnels">
        <div class="bl-hero-card__media">
          <img src="https://basic-cosmetics.bio/cdn/shop/files/basic_black.png?v=1741897875&width=600" alt="basic. professionnels" loading="lazy" style="object-fit:contain;padding:36px;background:var(--bl-cream-soft);">
        </div>
        <div class="bl-hero-card__body">
          <div class="bl-hero-card__text">
            <div class="bl-hero-card__eyebrow">Espace pro</div>
            <div class="bl-hero-card__title">Ton compte professionnel</div>
            <div class="bl-hero-card__sub">Catalogue B2B, tarifs revendeur, conditions et contacts dédiés.</div>
          </div>
          <span class="bl-hero-card__arrow">→</span>
        </div>
      </a>
    ` : `
      <a class="bl-hero-card" href="/collections/deodorants">
        <div class="bl-hero-card__media">
          <img src="https://basic-cosmetics.bio/cdn/shop/files/hf_20260501_142352_cc426dd0-1617-4dff-8a09-ce800da77aef.png?v=1777645752&width=600" alt="Kit KIIMA déodorant" loading="lazy">
        </div>
        <div class="bl-hero-card__body">
          <div class="bl-hero-card__text">
            <div class="bl-hero-card__eyebrow">À découvrir</div>
            <div class="bl-hero-card__title">Le système KIIMA</div>
            <div class="bl-hero-card__sub">Un applicateur rechargeable conçu pour durer, avec des recharges disponibles.</div>
          </div>
          <span class="bl-hero-card__arrow">→</span>
        </div>
      </a>
    `;

    // Recently viewed carousel
    const recentSection = recent.length > 0 ? `
      <div>
        <div class="bl-section-head">
          <span class="bl-section-title">Vus récemment</span>
        </div>
        <div class="bl-carousel">
          ${recent.slice(0, 6).map(p => `
            <a class="bl-prod-card" href="/products/${escapeAttr(p.handle)}">
              <div class="bl-prod-card__media">${p.image ? `<img src="${escapeAttr(p.image)}" alt="" loading="lazy">` : ''}</div>
              <div class="bl-prod-card__body">
                <div class="bl-prod-card__title">${escapeHTML(p.title || '')}</div>
                ${p.price ? `<div class="bl-prod-card__price">${escapeHTML(p.price)} CHF</div>` : ''}
              </div>
            </a>
          `).join('')}
        </div>
      </div>
    ` : '';

    return `
      <div class="bl-tab-pane bl-tab-pane--active" data-pane="home">
        <div class="bl-pane">
          ${greeting}
          ${heroCard}
          ${orderCard ? `
            <div>
              <div class="bl-section-head">
                <span class="bl-section-title">Ta dernière commande</span>
                <a href="#" class="bl-section-link" data-go-tab="orders">Tout voir</a>
              </div>
              ${orderCard}
            </div>
          ` : ''}
          ${recentSection}
          <div>
            <div class="bl-section-head">
              <span class="bl-section-title">Raccourcis</span>
            </div>
            <div class="bl-actions">
              ${isB2B() ? `
                <a class="bl-action" href="/pages/professionnels">
                  <div class="bl-action__icon">${ICO.box}</div>
                  <div class="bl-action__body">
                    <div class="bl-action__title">Catalogue professionnels</div>
                    <div class="bl-action__sub">Tarifs revendeur, conditions B2B et nouveautés.</div>
                  </div>
                  <span class="bl-action__arrow">→</span>
                </a>
                <a class="bl-action" href="/collections/deodorants">
                  <div class="bl-action__icon">${ICO.refill}</div>
                  <div class="bl-action__body">
                    <div class="bl-action__title">Recharges & déodorants</div>
                    <div class="bl-action__sub">Les références B2B les plus commandées.</div>
                  </div>
                  <span class="bl-action__arrow">→</span>
                </a>
                <a class="bl-action" href="mailto:cs@basicbrand.ch?subject=Question%20B2B">
                  <div class="bl-action__icon">${ICO.chat}</div>
                  <div class="bl-action__body">
                    <div class="bl-action__title">Contact pro dédié</div>
                    <div class="bl-action__sub">Une question commerciale ou logistique ?</div>
                  </div>
                  <span class="bl-action__arrow">→</span>
                </a>
              ` : `
                <a class="bl-action" href="/pages/decouvre-ton-type-de-peau-quiz-gratuit">
                  <div class="bl-action__icon">${ICO.quiz}</div>
                  <div class="bl-action__body">
                    <div class="bl-action__title">Diagnostic peau</div>
                    <div class="bl-action__sub">6 questions, 2 min, routine sur mesure.</div>
                  </div>
                  <span class="bl-action__arrow">→</span>
                </a>
                <a class="bl-action" href="/collections/bestseller">
                  <div class="bl-action__icon">${ICO.sparkle}</div>
                  <div class="bl-action__body">
                    <div class="bl-action__title">Les bestsellers</div>
                    <div class="bl-action__sub">Ce que les autres ont adopté.</div>
                  </div>
                  <span class="bl-action__arrow">→</span>
                </a>
              `}
            </div>
          </div>
        </div>
      </div>
    `;
  }

  // ============================================================
  // ORDER TRACKING CARD
  // ============================================================
  function buildOrderTrackingCard(o) {
    const status = o.fulfillment_status || 'unfulfilled';
    const date = new Date(o.created_at).toLocaleDateString('fr-CH', { day: 'numeric', month: 'long' });
    const items = (o.line_items || []).slice(0, 4);
    const moreCount = (o.item_count || items.length) - items.length;
    const thumbs = items.map(li => li.image
      ? `<div class="bl-order__thumb"><img src="${escapeAttr(li.image)}" alt=""></div>`
      : `<div class="bl-order__thumb"></div>`
    ).join('') + (moreCount > 0 ? `<div class="bl-order__thumb bl-order__thumb--more">+${moreCount}</div>` : '');

    // Steps : Confirmée → Préparée → Expédiée → Livrée
    const stepIdx = status === 'fulfilled' ? 3 : (status === 'partial' ? 2 : 1);
    const steps = ['Confirmée', 'Préparée', 'Expédiée', 'Livrée'].map((label, i) => {
      const cls = i < stepIdx ? 'bl-step--done' : (i === stepIdx ? 'bl-step--current' : '');
      return `<div class="bl-step ${cls}"><span class="bl-step__bar"></span><span class="bl-step__dot"></span><span class="bl-step__label">${label}</span></div>`;
    }).join('');

    const titles = items.map(li => li.title).join(', ');
    const statusPill = status === 'fulfilled'
      ? '<span class="bl-pill bl-pill--green">Livrée</span>'
      : status === 'partial'
      ? '<span class="bl-pill bl-pill--blue">En cours</span>'
      : '<span class="bl-pill bl-pill--amber">En préparation</span>';

    return `
      <div class="bl-order">
        <div class="bl-order__head">
          <div>
            <div class="bl-order__title">${escapeHTML(o.name)}</div>
            <div class="bl-order__date">${escapeHTML(date)}</div>
          </div>
          ${statusPill}
        </div>
        <div class="bl-steps">${steps}</div>
        ${thumbs ? `<div class="bl-order__thumbs">${thumbs}</div>` : ''}
        ${titles ? `<div class="bl-order__items">${escapeHTML(titles.length > 90 ? titles.slice(0, 90) + '…' : titles)}</div>` : ''}
        <div class="bl-order__foot">
          ${o.order_status_url ? `<a class="bl-btn bl-btn--ghost bl-btn--sm" href="${escapeAttr(o.order_status_url)}" target="_blank" rel="noopener">Suivre</a>` : '<span></span>'}
          <span class="bl-order__total">${escapeHTML(o.total_price)} CHF</span>
        </div>
      </div>
    `;
  }

  // ============================================================
  // TAB : COMMANDES
  // ============================================================
  function buildOrders() {
    const c = state.customer;
    if (!c) {
      return `
        <div class="bl-tab-pane" data-pane="orders">
          ${buildLoginEmpty('Tes commandes.', 'Connecte-toi pour voir l\'historique de tes commandes et suivre celles en cours.')}
        </div>
      `;
    }
    const orders = state.orders || [];
    if (orders.length === 0) {
      return `
        <div class="bl-tab-pane" data-pane="orders">
          <div class="bl-pane">
            <div class="bl-empty">
              <div class="bl-empty__icon">${ICO.box}</div>
              <div class="bl-empty__title">Aucune commande.</div>
              <div class="bl-empty__text">Quand tu auras passé ta première commande, elle s'affichera ici avec son statut en temps réel.</div>
              <div class="bl-empty__cta">
                <a href="/collections/bestseller" class="bl-btn bl-btn--primary">Découvrir basic.</a>
              </div>
            </div>
          </div>
        </div>
      `;
    }
    const listHTML = orders.map(o => buildOrderTrackingCard(o)).join('');
    return `
      <div class="bl-tab-pane" data-pane="orders">
        <div class="bl-pane">
          <div class="bl-filter-tabs" data-filter-bar>
            <button class="bl-filter-tab bl-filter-tab--active" data-filter="all">Toutes</button>
            <button class="bl-filter-tab" data-filter="open">En cours</button>
            <button class="bl-filter-tab" data-filter="done">Livrées</button>
          </div>
          <div class="bl-orders-list" id="bl-orders-list">
            ${listHTML}
          </div>
        </div>
      </div>
    `;
  }

  // ============================================================
  // TAB : CLUB
  // ============================================================
  function buildClub() {
    const c = state.customer;
    if (!c) {
      return `
        <div class="bl-tab-pane" data-pane="club">
          ${buildLoginEmpty('Le Club basic.', 'Cumule des points, parraine tes proches, débloque des avantages. Connecte-toi pour rejoindre le Club.')}
        </div>
      `;
    }
    const tier = tierFromCustomer(c);
    const tierLabel = { essentiel: 'Essentiel', signature: 'Signature', iconique: 'Iconique' }[tier];
    const points = Math.round(parseFloat(c.total_spent || 0) * 5);
    const thresholds = { essentiel: 0, signature: 750, iconique: 1500 };
    const nextTier = tier === 'essentiel' ? 'signature' : (tier === 'signature' ? 'iconique' : null);
    const curMin = thresholds[tier];
    const nextMin = nextTier ? thresholds[nextTier] : points;
    const pct = nextTier ? Math.min(100, Math.round(((points - curMin) / (nextMin - curMin)) * 100)) : 100;
    const ptsToNext = nextTier ? (nextMin - points) : 0;

    const perks = buildPerks(tier);
    const refCode = c.email ? ('REF-' + (c.email.split('@')[0] || '').toUpperCase().slice(0, 8)) : 'REF-BASIC';

    return `
      <div class="bl-tab-pane" data-pane="club">
        <div class="bl-pane">
          <div class="bl-tier-card">
            <div class="bl-tier-card__label">Ton palier</div>
            <div class="bl-tier-card__name">${tierLabel}</div>
            <div class="bl-tier-card__points">${points.toLocaleString('fr-CH')}</div>
            <div class="bl-tier-card__points-label">points cumulés</div>
            ${nextTier ? `
              <div class="bl-tier-card__progress">
                <div class="bl-tier-card__progress-bar">
                  <div class="bl-tier-card__progress-fill" style="width:${pct}%"></div>
                </div>
                <div class="bl-tier-card__progress-text">Encore ${ptsToNext.toLocaleString('fr-CH')} points pour atteindre <strong>${nextTier}</strong></div>
              </div>
            ` : `
              <div class="bl-tier-card__progress">
                <div class="bl-tier-card__progress-text">Tu es au palier maximum — merci pour ta fidélité.</div>
              </div>
            `}
          </div>
          <div>
            <div class="bl-section-head">
              <span class="bl-section-title">Tes avantages débloqués</span>
            </div>
            <div class="bl-perks">${perks}</div>
          </div>
          <div>
            <div class="bl-section-head">
              <span class="bl-section-title">Parrainage</span>
            </div>
            <div class="bl-ref">
              <div class="bl-ref__code">
                <span class="bl-ref__code-val">${escapeHTML(refCode)}</span>
                <button class="bl-ref__copy" data-copy="${escapeAttr('https://basic-cosmetics.bio?ref=' + refCode)}">Copier</button>
              </div>
              <div class="bl-ref__text">Partage ton code à un proche : il reçoit 250 points sur sa première commande, tu en reçois 250 quand il commande.</div>
            </div>
          </div>
          <div>
            <a href="/pages/basic-le-club" class="bl-btn bl-btn--ghost bl-btn--block">Tous les avantages du Club</a>
          </div>
        </div>
      </div>
    `;
  }

  function buildPerks(tier) {
    const sets = {
      essentiel: [
        { icon: ICO.percent, text: '<strong>5 points</strong> par CHF dépensé' },
        { icon: ICO.gift,    text: '<strong>Cadeau mini</strong> pour ton anniversaire' },
        { icon: ICO.star,    text: '<strong>100 points</strong> par avis produit' },
        { icon: ICO.truck,   text: 'Livraison offerte dès <strong>70 CHF</strong>' }
      ],
      signature: [
        { icon: ICO.percent, text: '<strong>-5%</strong> réduction permanente' },
        { icon: ICO.gift,    text: '<strong>Cadeau produit</strong> pour ton anniversaire' },
        { icon: ICO.drop,    text: '<strong>Échantillon offert</strong> à chaque commande' },
        { icon: ICO.truck,   text: 'Livraison offerte dès <strong>60 CHF</strong>' },
        { icon: ICO.lock,    text: 'Ventes privées <strong>48h avant</strong>' }
      ],
      iconique: [
        { icon: ICO.percent, text: '<strong>-10%</strong> réduction permanente' },
        { icon: ICO.gift,    text: '<strong>Cadeau mystère</strong> pour ton anniversaire' },
        { icon: ICO.drop,    text: '<strong>Échantillon offert</strong> à chaque commande' },
        { icon: ICO.truck,   text: 'Livraison offerte dès <strong>50 CHF</strong>' },
        { icon: ICO.lock,    text: 'Ventes privées <strong>96h avant</strong>' }
      ]
    };
    return (sets[tier] || sets.essentiel).map(p => `
      <div class="bl-perk">
        <div class="bl-perk__icon">${p.icon}</div>
        <div class="bl-perk__text">${p.text}</div>
      </div>
    `).join('');
  }

  function tierFromCustomer(c) {
    const tags = (c.tags || '').toLowerCase();
    if (tags.includes('iconique')) return 'iconique';
    if (tags.includes('signature')) return 'signature';
    // Fallback : compute from total_spent (5 pts/CHF)
    const pts = Math.round(parseFloat(c.total_spent || 0) * 5);
    if (pts >= 1500) return 'iconique';
    if (pts >= 750) return 'signature';
    return 'essentiel';
  }

  // ============================================================
  // TAB : PROFIL
  // ============================================================
  function buildProfile() {
    const c = state.customer;
    if (!c) {
      return `
        <div class="bl-tab-pane" data-pane="profile">
          ${buildLoginEmpty('Ton compte.', 'Connecte-toi pour gérer ton adresse, ton téléphone, tes préférences newsletter et ton compte basic.')}
        </div>
      `;
    }
    const name = [c.first_name, c.last_name].filter(Boolean).join(' ') || c.email;
    const initials = (name.split(' ').map(s => s[0]).join('').slice(0, 2) || 'B').toUpperCase();
    const addr = c.default_address;
    const phone = c.phone || (addr && addr.phone) || '';

    const addressHTML = addr ? `
      <div class="bl-address-block">
        <div class="bl-address-block__text">
          ${escapeHTML(addr.first_name || '')} ${escapeHTML(addr.last_name || '')}<br>
          ${addr.company ? escapeHTML(addr.company) + '<br>' : ''}
          ${escapeHTML(addr.address1 || '')}${addr.address2 ? '<br>' + escapeHTML(addr.address2) : ''}<br>
          ${escapeHTML(addr.zip || '')} ${escapeHTML(addr.city || '')}<br>
          ${escapeHTML(addr.country || '')}
        </div>
        <a data-k-hub-ignore="true" href="/account/addresses" class="bl-address-block__edit-link">Modifier l'adresse</a>
      </div>
    ` : `
      <div class="bl-address-block">
        <div class="bl-address-block__text" style="color:var(--bl-ink-60);">Aucune adresse enregistrée.</div>
        <a data-k-hub-ignore="true" href="/account/addresses" class="bl-address-block__edit-link">Ajouter une adresse</a>
      </div>
    `;

    return `
      <div class="bl-tab-pane" data-pane="profile">
        <div class="bl-pane">
          <div class="bl-profile-hero">
            <div class="bl-avatar">${escapeHTML(initials)}</div>
            <div class="bl-profile-hero__info">
              <div class="bl-profile-hero__name">${escapeHTML(name)}</div>
              <div class="bl-profile-hero__email">${escapeHTML(c.email || '')}</div>
            </div>
          </div>

          <div>
            <div class="bl-section-head"><span class="bl-section-title">Informations</span></div>
            <div class="bl-field-list">
              <div class="bl-field-row">
                <span class="bl-field-row__label">Téléphone</span>
                <span class="bl-field-row__value">${escapeHTML(phone || '—')}</span>
              </div>
              <div class="bl-field-row" data-bday-row>
                <span class="bl-field-row__label">Anniversaire</span>
                ${c.birthday ? `
                  <span class="bl-field-row__value">${escapeHTML(formatBirthday(c.birthday))}</span>
                  <button type="button" data-bday-edit style="background:transparent;border:none;color:var(--bl-ink-60);font-size:13px;cursor:pointer;text-decoration:underline;padding:0;margin-left:8px;">Modifier</button>
                ` : `
                  <button type="button" data-bday-edit style="background:transparent;border:none;color:var(--bl-accent,#000);font-size:13px;cursor:pointer;text-decoration:underline;padding:0;font-weight:600;">Configurer</button>
                `}
              </div>
              <div class="bl-field-row" data-bday-form hidden style="display:flex;flex-direction:column;gap:8px;align-items:stretch;">
                <input type="date" id="bl-bday-input" max="${new Date().toISOString().slice(0,10)}" value="${escapeHTML(c.birthday || '')}" style="font-size:16px;padding:10px 12px;border:1px solid var(--bl-ink-20,#e0e0e0);border-radius:8px;width:100%;font-family:inherit;background:#fff;">
                <div style="display:flex;gap:8px;">
                  <button type="button" id="bl-bday-save" style="flex:1;background:var(--bl-ink,#000);color:#fff;border:none;padding:10px 16px;border-radius:8px;font-size:13px;font-weight:600;cursor:pointer;font-family:inherit;">Enregistrer</button>
                  <button type="button" data-bday-cancel style="background:transparent;color:var(--bl-ink-60,#666);border:1px solid var(--bl-ink-20,#e0e0e0);padding:10px 16px;border-radius:8px;font-size:13px;cursor:pointer;font-family:inherit;">Annuler</button>
                </div>
              </div>
              <div class="bl-field-row">
                <span class="bl-field-row__label">Newsletter</span>
                <span class="bl-pill bl-pill--green">${ICO.check} Active</span>
              </div>
            </div>
          </div>

          <div>
            <div class="bl-section-head"><span class="bl-section-title">Adresse de livraison</span></div>
            ${addressHTML}
          </div>

          <div>
            <a data-k-hub-ignore="true" href="/account" class="bl-btn bl-btn--ghost bl-btn--block">Voir mon compte complet</a>
          </div>
          <div style="text-align:center;margin-top:8px;">
            <a data-k-hub-ignore="true" href="/account/logout" class="bl-empty__cta-secondary">Se déconnecter</a>
          </div>
        </div>
      </div>
    `;
  }

  // ============================================================
  // EMPTY STATE (logged out)
  // ============================================================
  function buildLoginEmpty(title, text) {
    return `
      <div class="bl-pane">
        <div class="bl-empty">
          <div class="bl-empty__icon">${ICO.lock}</div>
          <div class="bl-empty__title">${escapeHTML(title)}</div>
          <div class="bl-empty__text">${escapeHTML(text)}</div>
          <div class="bl-empty__cta">
            <a data-k-hub-ignore="true" href="/account/login" class="bl-btn bl-btn--primary">Se connecter</a>
            <a data-k-hub-ignore="true" href="/account/register" class="bl-empty__cta-secondary">Créer un compte</a>
          </div>
        </div>
      </div>
    `;
  }

  // ============================================================
  // EVENTS
  // ============================================================
  function attachEvents() {
    document.getElementById('bl-fab')?.addEventListener('click', () => toggle(true));
    document.getElementById('bl-close')?.addEventListener('click', () => toggle(false));
    document.getElementById('bl-overlay')?.addEventListener('click', () => toggle(false));

    document.querySelectorAll('.bl-nav__item').forEach(btn => {
      btn.addEventListener('click', () => switchTab(btn.dataset.tab));
    });

    document.querySelectorAll('[data-go-tab]').forEach(el => {
      el.addEventListener('click', e => { e.preventDefault(); switchTab(el.dataset.goTab); });
    });

    document.querySelectorAll('[data-copy]').forEach(el => {
      el.addEventListener('click', () => copyToClipboard(el.dataset.copy));
    });

    document.querySelectorAll('[data-filter-bar] [data-filter]').forEach(btn => {
      btn.addEventListener('click', () => filterOrders(btn));
    });

    // FAQ filter
    document.querySelectorAll('[data-faq-filter-bar] [data-faq-cat]').forEach(btn => {
      btn.addEventListener('click', () => filterFAQ(btn));
    });

    // Chat send
    document.getElementById('bl-chat-send')?.addEventListener('click', sendChatMessage);

    // Birthday inline edit
    document.querySelector('[data-bday-edit]')?.addEventListener('click', () => {
      document.querySelector('[data-bday-row]').hidden = true;
      document.querySelector('[data-bday-form]').hidden = false;
      document.getElementById('bl-bday-input')?.focus();
    });
    document.querySelector('[data-bday-cancel]')?.addEventListener('click', () => {
      document.querySelector('[data-bday-form]').hidden = true;
      document.querySelector('[data-bday-row]').hidden = false;
    });
    document.getElementById('bl-bday-save')?.addEventListener('click', saveBirthday);

    if (!state.escapeBound) {
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && state.open) toggle(false);
      });
      state.escapeBound = true;
    }
  }

  function formatBirthday(iso) {
    // Défensif : le metafield peut arriver comme objet {value} ou date complète
    if (!iso) return '';
    if (typeof iso === 'object') iso = iso.value || iso.date || '';
    iso = String(iso).slice(0, 10); // garde YYYY-MM-DD même si datetime
    const parts = iso.split('-');
    if (parts.length < 3) return iso;
    const [y, m, d] = parts;
    if (!y || !m || !d) return iso;
    const months = ['janv.','févr.','mars','avr.','mai','juin','juil.','août','sept.','oct.','nov.','déc.'];
    const mi = parseInt(m, 10) - 1;
    if (mi < 0 || mi > 11) return iso;
    return `${parseInt(d, 10)} ${months[mi]} ${y}`;
  }

  async function saveBirthday() {
    const input = document.getElementById('bl-bday-input');
    const btn = document.getElementById('bl-bday-save');
    const value = input?.value;
    if (!value) return;
    const c = state.customer;
    if (!c) return;

    btn.disabled = true;
    const prevLabel = btn.textContent;
    btn.textContent = 'Enregistrement…';

    try {
      const res = await fetch(`${SUPABASE_URL}/functions/v1/basic-lab-profile`, {
        method: 'POST',
        headers: supaHeaders(),
        body: JSON.stringify({
          customer_id: c.id,
          email: c.email,
          birthday: value,
        }),
      });
      const data = await res.json();
      if (!res.ok || !data.ok) {
        console.error('basic-lab-profile error', data);
        btn.textContent = 'Erreur — réessaie';
        setTimeout(() => { btn.textContent = prevLabel; btn.disabled = false; }, 2000);
        return;
      }
      // Update local state and re-render
      state.customer.birthday = value;
      const wasOpen = state.open;
      render();
      attachEvents();           // ← re-bind les listeners (FAB, close, tabs, save…)
      // Restaure l'état ouvert SANS retoucher le scroll-lock du body
      // (déjà verrouillé : repasser par toggle() écraserait _scrollY).
      if (wasOpen) {
        state.open = true;
        document.getElementById('bl-panel')?.classList.add('bl-panel--open');
        document.getElementById('bl-fab')?.classList.add('bl-fab--hidden');
        document.getElementById('bl-overlay')?.classList.add('bl-overlay--visible');
      }
      switchTab('profile');
      showToast('Anniversaire enregistré');
    } catch (err) {
      console.error(err);
      btn.textContent = 'Erreur réseau';
      setTimeout(() => { btn.textContent = prevLabel; btn.disabled = false; }, 2000);
    }
  }

  function filterFAQ(btn) {
    const cat = btn.dataset.faqCat;
    document.querySelectorAll('[data-faq-filter-bar] [data-faq-cat]').forEach(b =>
      b.classList.toggle('bl-filter-tab--active', b === btn)
    );
    document.querySelectorAll('.bl-faq-item').forEach(item => {
      const itemCat = item.dataset.faqCat;
      item.style.display = (cat === 'Tout' || itemCat === cat) ? '' : 'none';
    });
  }

  // ============================================================
  // CHAT : envoi vers Supabase Edge Function basic-lab-chat
  // Flow : POST /conversations → POST /messages
  // ============================================================
  // Construit le contexte client pour l'agent support (visible dans basic. lab v2)
  function buildCustomerContext() {
    const c = state.customer;
    const ctx = {
      page_url: location.href,
      page_title: document.title,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent,
      viewport: { w: window.innerWidth, h: window.innerHeight },
      language: navigator.language,
      timestamp: new Date().toISOString()
    };
    if (c) {
      ctx.customer = {
        id: c.id,
        email: c.email,
        name: c.name || ((c.first_name||'') + ' ' + (c.last_name||'')).trim(),
        phone: c.phone || null,
        tags: c.tags || '',
        is_b2b: !!c.is_b2b,
        orders_count: c.orders_count || 0,
        total_spent: c.total_spent || '0.00',
        tier: tierFromCustomer(c)
      };
      if (c.default_address) {
        ctx.customer.address = {
          city: c.default_address.city,
          zip: c.default_address.zip,
          country: c.default_address.country
        };
      }
    }
    // Dernière commande pour contexte produits
    if (state.orders && state.orders[0]) {
      const o = state.orders[0];
      ctx.last_order = {
        name: o.name,
        status: o.fulfillment_status,
        total: o.total_price + ' CHF',
        date: o.created_at,
        items: (o.line_items || []).map(li => li.title).slice(0, 5)
      };
    }
    // Produits vus récemment
    const recent = getRecentlyViewed();
    if (recent.length > 0) {
      ctx.recently_viewed = recent.slice(0, 5).map(p => p.title);
    }
    return ctx;
  }

  async function ensureConversation(emailOverride) {
    if (state.conversationId) {
      // Si on a un email (capturé) et que la conv existe, on le pousse quand même
      if (emailOverride) {
        fetch(EDGE_FN_URL + '/conversations', {
          method: 'POST', headers: supaHeaders(),
          body: JSON.stringify({ session_id: state.sessionId, customer_email: emailOverride, page_url: location.href })
        }).catch(() => {});
      }
      return state.conversationId;
    }
    const c = state.customer;
    const ctx = buildCustomerContext();
    const body = {
      session_id: state.sessionId,
      customer_email: (c && c.email) || emailOverride || null,
      customer_name: ctx.customer ? ctx.customer.name : null,
      customer_phone: c ? (c.phone || null) : null,
      page_url: location.href,
      context: ctx
    };
    const res = await fetch(EDGE_FN_URL + '/conversations', {
      method: 'POST',
      headers: supaHeaders(),
      body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error('Conv create failed (' + res.status + ')');
    const data = await res.json();
    state.conversationId = data.conversation_id;
    setStoredConversationId(state.conversationId);
    return state.conversationId;
  }

  // ── Fil de discussion : fetch + render ──────────────────────
  async function fetchChatMessages() {
    if (!state.conversationId) return;
    try {
      const res = await fetch(EDGE_FN_URL + '/messages?conversation_id=' + encodeURIComponent(state.conversationId), {
        headers: supaHeaders()
      });
      if (!res.ok) return;
      const data = await res.json();
      const msgs = Array.isArray(data.messages) ? data.messages : [];
      // Ne garde pas les notes internes (le backend ne les renvoie pas, mais par sécurité)
      state.chatMessages = msgs;
      state.chatCsat = (typeof data.csat_score === 'number') ? data.csat_score : null;
      state.chatLoaded = true;
      renderChatThread();
    } catch (e) { /* silencieux */ }
  }

  function renderChatThread() {
    const thread = document.getElementById('bl-chat-thread');
    if (!thread) return;
    const msgs = state.chatMessages || [];
    if (msgs.length === 0) { thread.style.display = 'none'; return; }
    thread.style.display = 'block';

    const fmt = (iso) => {
      try {
        return new Date(iso).toLocaleString('fr-CH', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
      } catch (e) { return ''; }
    };
    const csatGiven = (typeof state.chatCsat === 'number');
    thread.innerHTML = msgs.map(m => {
      // ── Bloc satisfaction (demande CSAT) ──
      if (m.message_type === 'csat_request') {
        if (csatGiven) {
          const em = state.chatCsat === 1 ? '😞' : state.chatCsat === 2 ? '🙂' : '😍';
          return `
            <div style="display:flex;justify-content:center;margin:10px 0;">
              <div style="background:#fff;border:1px solid var(--bl-ink-12,rgba(28,26,23,.12));border-radius:12px;padding:12px 16px;text-align:center;font-size:13px;color:var(--bl-ink-60,#6B6560);">
                Merci pour ton retour ! <span style="font-size:18px;">${em}</span>
              </div>
            </div>`;
        }
        return `
          <div style="display:flex;justify-content:center;margin:10px 0;">
            <div style="background:#fff;border:1px solid var(--bl-ink-12,rgba(28,26,23,.12));border-radius:12px;padding:14px 16px;text-align:center;max-width:90%;">
              <div style="font-size:13px;color:var(--bl-ink,#1C1A17);margin-bottom:10px;">${escapeHTML(m.text)}</div>
              <div style="display:flex;gap:14px;justify-content:center;">
                <button type="button" data-csat="1" style="background:none;border:none;font-size:30px;cursor:pointer;line-height:1;padding:4px;transition:transform .1s;" aria-label="Déçu">😞</button>
                <button type="button" data-csat="2" style="background:none;border:none;font-size:30px;cursor:pointer;line-height:1;padding:4px;transition:transform .1s;" aria-label="Correct">🙂</button>
                <button type="button" data-csat="3" style="background:none;border:none;font-size:30px;cursor:pointer;line-height:1;padding:4px;transition:transform .1s;" aria-label="Ravi">😍</button>
              </div>
            </div>
          </div>`;
      }
      // ── Réponse CSAT du client (juste l'émoji, aligné à droite) ──
      if (m.message_type === 'csat_response') {
        return `
          <div style="display:flex;justify-content:flex-end;margin-bottom:8px;">
            <div style="font-size:26px;line-height:1;">${escapeHTML(m.text)}</div>
          </div>`;
      }
      // ── Message normal ──
      const isAgent = m.sender === 'agent';
      const align = isAgent ? 'flex-start' : 'flex-end';
      const bg = isAgent ? '#fff' : 'var(--bl-ink,#1C1A17)';
      const color = isAgent ? 'var(--bl-ink,#1C1A17)' : '#fff';
      const border = isAgent ? '1px solid var(--bl-ink-12,rgba(28,26,23,.12))' : 'none';
      const radius = isAgent ? '12px 12px 12px 4px' : '12px 12px 4px 12px';
      const label = isAgent ? '<div style="font-size:9px;letter-spacing:.12em;text-transform:uppercase;color:var(--bl-ink-40,#999);margin-bottom:3px;">basic.</div>' : '';
      return `
        <div style="display:flex;justify-content:${align};margin-bottom:8px;">
          <div style="max-width:80%;background:${bg};color:${color};border:${border};border-radius:${radius};padding:9px 12px;font-size:13.5px;line-height:1.45;box-shadow:0 1px 2px rgba(0,0,0,.04);">
            ${label}
            <div style="white-space:pre-wrap;">${escapeHTML(m.text)}</div>
            <div style="font-size:9px;opacity:.5;margin-top:4px;">${fmt(m.created_at)}</div>
          </div>
        </div>`;
    }).join('');
    // Wire les boutons CSAT (le thread est re-rendu à chaque poll)
    thread.querySelectorAll('[data-csat]').forEach(btn => {
      btn.addEventListener('click', () => submitCsat(parseInt(btn.dataset.csat, 10)));
    });
    thread.scrollTop = thread.scrollHeight;
  }

  async function submitCsat(score) {
    if (!state.conversationId || ![1, 2, 3].includes(score)) return;
    // Optimiste : marque la note + ajoute la bulle réponse
    state.chatCsat = score;
    const emoji = score === 1 ? '😞' : score === 2 ? '🙂' : '😍';
    state.chatMessages = [...(state.chatMessages || []), { id: 'tmp-csat-' + Date.now(), sender: 'customer', text: emoji, message_type: 'csat_response', created_at: new Date().toISOString() }];
    renderChatThread();
    try {
      await fetch(EDGE_FN_URL + '/csat', {
        method: 'POST',
        headers: supaHeaders(),
        body: JSON.stringify({ conversation_id: state.conversationId, score })
      });
      showToast('Merci pour ton retour !');
      fetchChatMessages();
    } catch (e) { console.error('csat error', e); }
  }

  function startChatPolling() {
    stopChatPolling();
    if (!state.conversationId) return;
    // Poll toutes les 6s tant que l'onglet Aide est ouvert + panneau ouvert
    state.chatPollTimer = setInterval(() => {
      if (state.open && state.tab === 'help' && state.conversationId) {
        fetchChatMessages();
      }
    }, 6000);
  }
  function stopChatPolling() {
    if (state.chatPollTimer) { clearInterval(state.chatPollTimer); state.chatPollTimer = null; }
  }

  async function sendChatMessage() {
    const ta = document.getElementById('bl-chat-input');
    const btn = document.getElementById('bl-chat-send');
    const emailInput = document.getElementById('bl-chat-email');
    if (!ta || !btn) return;
    const text = (ta.value || '').trim();
    if (!text) { ta.focus(); return; }
    if (text.length < 5) { showToast('Message trop court'); ta.focus(); return; }

    // Capture email pour visiteur anonyme
    let email = getChatEmail();
    if (!email && emailInput) {
      const v = (emailInput.value || '').trim();
      if (!v || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) {
        showToast('Entre un email valide pour qu\'on te réponde');
        emailInput.focus();
        return;
      }
      email = v;
      setChatEmail(email);
    }

    btn.disabled = true;
    const originalLabel = btn.textContent;
    btn.textContent = 'Envoi…';

    // Optimiste : ajoute le message au fil tout de suite
    state.chatMessages = [...(state.chatMessages || []), { id: 'tmp-' + Date.now(), sender: 'customer', text, created_at: new Date().toISOString() }];
    renderChatThread();
    ta.value = '';
    if (typeof ta.style !== 'undefined') ta.style.height = 'auto';

    try {
      const convId = await ensureConversation(email);
      const res = await fetch(EDGE_FN_URL + '/messages', {
        method: 'POST',
        headers: supaHeaders(),
        body: JSON.stringify({ conversation_id: convId, text })
      });
      if (!res.ok) throw new Error('Send failed (' + res.status + ')');

      // Cache le champ email après 1er envoi réussi
      if (emailInput) emailInput.style.display = 'none';
      const hint = document.getElementById('bl-chat-hint');
      if (hint) hint.textContent = 'Message envoyé · on te répond ici';

      // Recharge le fil (récupère id réel + auto-reply éventuel)
      await fetchChatMessages();
      startChatPolling();
    } catch (e) {
      console.error('basic.lab chat error:', e);
      showToast('Erreur · écris à cs@basicbrand.ch');
    } finally {
      btn.disabled = false;
      btn.textContent = originalLabel;
    }
  }

  // Re-attache events Help après re-render
  function attachHelpEvents() {
    document.querySelectorAll('[data-faq-filter-bar] [data-faq-cat]').forEach(btn => {
      btn.addEventListener('click', () => filterFAQ(btn));
    });
    document.getElementById('bl-chat-send')?.addEventListener('click', sendChatMessage);
    document.getElementById('bl-chat-input')?.addEventListener('keydown', e => {
      if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) { e.preventDefault(); sendChatMessage(); }
    });
    // Affiche le fil si déjà chargé
    if (state.chatLoaded) renderChatThread();
  }

  function toggle(open) {
    if (open && !document.getElementById('bl-panel')) {
      const root = document.getElementById('basic-lab-widget');
      if (root) {
        root.innerHTML = buildShell();
        attachEvents();
      }
    }
    if (open && !state.faqsRequested) {
      state.faqsRequested = true;
      fetchFAQs();
    }
    state.open = open;
    document.getElementById('bl-panel')?.classList.toggle('bl-panel--open', open);
    document.getElementById('bl-fab')?.classList.toggle('bl-fab--hidden', open);
    document.getElementById('bl-overlay')?.classList.toggle('bl-overlay--visible', open);
    // iOS : verrouille le scroll body pour éviter que la page glisse sous le panneau
    if (open) {
      state._scrollY = window.scrollY;
      document.body.classList.add('bl-lock');
      document.body.style.top = `-${state._scrollY}px`;
    } else {
      document.body.classList.remove('bl-lock');
      document.body.style.top = '';
      if (typeof state._scrollY === 'number') window.scrollTo(0, state._scrollY);
      stopChatPolling();
    }
    // Si on ouvre directement sur l'onglet Aide avec une conv existante
    if (open && state.tab === 'help' && state.conversationId) {
      fetchChatMessages(); startChatPolling();
    }
  }

  function switchTab(tab) {
    state.tab = tab;
    document.querySelectorAll('.bl-nav__item').forEach(b => b.classList.toggle('bl-nav__item--active', b.dataset.tab === tab));
    document.querySelectorAll('.bl-tab-pane').forEach(p => p.classList.toggle('bl-tab-pane--active', p.dataset.pane === tab));
    document.querySelector('.bl-content').scrollTop = 0;
    // Chat live : charge le fil + lance le polling sur l'onglet Aide
    if (tab === 'help') {
      if (state.conversationId) { fetchChatMessages(); startChatPolling(); }
    } else {
      stopChatPolling();
    }
  }

  function filterOrders(btn) {
    const filter = btn.dataset.filter;
    state.orderFilter = filter;
    document.querySelectorAll('[data-filter-bar] [data-filter]').forEach(b =>
      b.classList.toggle('bl-filter-tab--active', b === btn)
    );
    document.querySelectorAll('#bl-orders-list .bl-order').forEach((card, idx) => {
      const order = state.orders[idx];
      if (!order) return;
      let show = true;
      if (filter === 'open') show = order.fulfillment_status !== 'fulfilled';
      else if (filter === 'done') show = order.fulfillment_status === 'fulfilled';
      card.style.display = show ? '' : 'none';
    });
  }

  function copyToClipboard(text) {
    const done = () => showToast('Code copié');
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done).catch(() => fallback());
    } else fallback();
    function fallback() {
      const ta = document.createElement('textarea');
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); done(); } catch (e) {}
      document.body.removeChild(ta);
    }
  }

  function showToast(msg) {
    const t = document.getElementById('bl-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('bl-toast--visible');
    clearTimeout(t._timer);
    t._timer = setTimeout(() => t.classList.remove('bl-toast--visible'), 2200);
  }

  // ============================================================
  // HELPERS
  // ============================================================
  function escapeHTML(s) {
    if (s == null) return '';
    const d = document.createElement('div');
    d.textContent = String(s);
    return d.innerHTML;
  }
  function escapeAttr(s) {
    return escapeHTML(s).replace(/"/g, '&quot;');
  }

  // ============================================================
  // BOOT
  // ============================================================
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
